import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";

export default function PageShell({ title, subtitle, onEnquire, showBack = true, children }) {
  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col">
      <Navbar onEnquire={onEnquire} />
      <section className="pt-28 pb-10 bg-gradient-to-br from-[#0a3d38] via-[#0a4f47] to-[#062a26] text-white">
        <div className="max-w-4xl mx-auto px-4 lg:px-8">
          {showBack && (
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-emerald-200 hover:text-white text-sm mb-4"
            >
              <ArrowLeft className="w-4 h-4" /> Back to home
            </Link>
          )}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-emerald-100 mt-3 text-lg">{subtitle}</p>
          ) : null}
        </div>
      </section>
      <main className="flex-1 py-12 lg:py-16">
        <div className="max-w-4xl mx-auto px-4 lg:px-8">{children}</div>
      </main>
      <Footer />
      <FloatingActions onEnquire={onEnquire} />
    </div>
  );
}
